import { render, staticRenderFns } from "./PersonEdit.vue?vue&type=template&id=282b3576&scoped=true&"
import script from "./PersonEdit.vue?vue&type=script&lang=js&"
export * from "./PersonEdit.vue?vue&type=script&lang=js&"
import style0 from "./PersonEdit.vue?vue&type=style&index=0&id=282b3576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b3576",
  null
  
)

export default component.exports